import { Tab, Tabs } from '@material-ui/core'

export const TabsHeader = ({ value, onChange }) => {
  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    }
  }

  return (
    <Tabs
      style={{
        padding: '0 1em ',
      }}
      value={value}
      onChange={onChange}
      aria-label="basic tabs example"
      textColor="primary"
      variant="scrollable"
      scrollButtons="auto"
    >
      <Tab label="Envoyer à une copropriété" {...a11yProps(0)} />
      <Tab label="Emails envoyés" {...a11yProps(1)} />
    </Tabs>
  )
}
